import React, { useCallback, useContext, useState } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import { AssessmentSetStyles, WrapFooterBtns, WrapFooter, WrapList, WrapDroppable, WrapDragIcon, AssessmentName, WrapSectionList, WrapDraggable } from './Style'
import { useSelector } from 'react-redux';
import { map } from 'lodash';
import { CustomSection, XSSpaceBetween } from 'styles/GlobalStyle';
import { DragIndicator } from '@mui/icons-material';
import { Button, IconButtons } from 'components/Form';
import { createAssessmentsHooks } from '.';
import { visibleTypes } from 'keys';
import { AbilityContext } from 'components/Permissions/Can';
import { useDispatch } from 'react-redux';
import { actions } from 'store';

const CreateSet = () => {
    const { user } = useSelector(state => state.user)
    const { selectedAssessmentDefs } = useSelector(state => state.assessment)
    const ability = useContext(AbilityContext)
    const dispatch = useDispatch()

    const layoutTypeBtns = createAssessmentsHooks.useLayoutTypeBtns()
    const batteryAllocationBtn = createAssessmentsHooks.useBatteryAllocationBtn()

    const handleLayout = useCallback((val, index) => {
        let nSelectedAssessmentDefs = [...selectedAssessmentDefs]
        nSelectedAssessmentDefs[index] = { ...nSelectedAssessmentDefs[index], layoutType: val }
        dispatch(actions.setSelectedAssessmentDefs(nSelectedAssessmentDefs))
    }, [selectedAssessmentDefs])

    const handleOnDragEnd = (result) => {
        if (!result.destination) return;

        let items = Array.from(selectedAssessmentDefs);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        dispatch(actions.setSelectedAssessmentDefs(items))
    }

    return (
        <AssessmentSetStyles>
            <div className='header-set'>
                <div className='title'>
                    {"V להוספת מבדקים לסוללה"}
                </div>
                <div className='sub-title'>
                    {ability.cannot("manage", "super-user") &&
                        `יש לך זכאות ליצור ${user?.balance} מבדקים`}
                </div>
            </div>
            <WrapSectionList>
                <CustomSection $bg $grow $flex $border>
                    <DragDropContext onDragEnd={handleOnDragEnd}>
                        <WrapDroppable droppableId="characters">
                            {(provided) => (
                                <WrapList className="characters" {...provided.droppableProps} ref={provided.innerRef}>
                                    {map(selectedAssessmentDefs).map(({ id, name, layoutType, layoutTypeDef, visible_type }, index) => {
                                        return (
                                            <WrapDraggable key={id.toString()} draggableId={id.toString()} index={index}>
                                                {(provided) => (
                                                    <CustomSection $flex justify="space-between" align="center" height={50} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                        <div className='drag-and-name'>
                                                            <WrapDragIcon>
                                                                <DragIndicator fontSize='small' color="white" />
                                                            </WrapDragIcon>
                                                            <AssessmentName>
                                                                {name}
                                                            </AssessmentName>
                                                        </div>
                                                        <XSSpaceBetween />
                                                        {
                                                            visible_type === visibleTypes.WORD_GROUP &&
                                                            <IconButtons
                                                                btns={layoutTypeBtns}
                                                                setSelected={(e, val) => handleLayout(val, index)}
                                                                selected={layoutType || layoutTypeDef}
                                                            />
                                                        }
                                                    </CustomSection>
                                                )}
                                            </WrapDraggable>
                                        );
                                    })}
                                    {provided.placeholder}
                                </WrapList>
                            )}
                        </WrapDroppable>
                    </DragDropContext>
                </CustomSection>
            </WrapSectionList>
            <WrapFooter>
                <WrapFooterBtns>
                    <Button  {...batteryAllocationBtn} />
                </WrapFooterBtns>
            </WrapFooter>
        </AssessmentSetStyles>
    );
}

export default CreateSet;
